import { render, staticRenderFns } from "./SifcopDigitized.vue?vue&type=template&id=466da7a1&scoped=true"
import script from "./SifcopDigitized.vue?vue&type=script&setup=true&lang=js"
export * from "./SifcopDigitized.vue?vue&type=script&setup=true&lang=js"
import style0 from "./SifcopDigitized.vue?vue&type=style&index=0&id=466da7a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "466da7a1",
  null
  
)

export default component.exports